import { DOCUMENT } from '@angular/common';
import { Component, HostListener, Inject, Input, Renderer2 } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-navigation',
  imports: [RouterModule],
  templateUrl: './navigation.html',
  styleUrls: ['./navigation.css']
})
export class Navigation {
  currentRoute: string | null = null;
  @Input() isAdmin: boolean = false;
  isCollapsed = false;
  private readonly mobileQuery = '(max-width: 767px)';
  private routerEventsSub?: Subscription;

  constructor(
    private router: Router,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) { }

  ngOnInit(): void {
    this.routerEventsSub = this.router.events.subscribe((val) => {
      this.currentRoute = this.router.url.replace("/", "");
    });
    this.updateForViewport();
  }

  ngOnDestroy(): void {
    this.routerEventsSub?.unsubscribe();
    this.renderer.removeClass(this.document.body, 'sidebar-collapsed');
    this.renderer.removeClass(this.document.body, 'sidebar-expanded');
  }

  @HostListener('window:resize')
  onResize(): void {
    this.updateForViewport();
  }

  toggleSidebar(): void {
    this.setCollapsedState(!this.isCollapsed);
  }

  private updateForViewport(): void {
    const isMobile = window.matchMedia
      ? window.matchMedia(this.mobileQuery).matches
      : window.innerWidth <= 767;

    if (isMobile && !this.isCollapsed) {
      this.setCollapsedState(true);
    } else if (!isMobile && this.isCollapsed) {
      this.setCollapsedState(false);
    }
  }

  private setCollapsedState(collapsed: boolean): void {
    this.isCollapsed = collapsed;
    if (collapsed) {
      this.renderer.addClass(this.document.body, 'sidebar-collapsed');
      this.renderer.removeClass(this.document.body, 'sidebar-expanded');
    } else {
      this.renderer.removeClass(this.document.body, 'sidebar-collapsed');
      this.renderer.addClass(this.document.body, 'sidebar-expanded');
    }
  }
}
